import React from 'react';
import Icon from '@material-ui/core/Icon';
import chevronDown from '@assets/chevron-down.svg';

function ChevronDown() {
  return (
    <Icon style={{ width: 'auto', height: 'auto' }}>
      <img alt="arrow" src={chevronDown} style={{ display: 'block' }} />
    </Icon>
  );
}

export default ChevronDown;
